import TechnologyDetailPage from "@/pages/technologies/components/TechnologyDetailPage";

export default function ReactTechPage() {
  return <TechnologyDetailPage slug="react" />;
}